export const ROUTES = {
  HOME: '/',
  CHAT: '/chat',
  DEBUG: '/debug',
} as const;
